/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Activity_Reading_PlanInputs */

const en_us2_coach_extra_activity_reading_plan = /** @type {(inputs: Coach_Extra_Activity_Reading_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading your plan…`)
};

const pt_br2_coach_extra_activity_reading_plan = /** @type {(inputs: Coach_Extra_Activity_Reading_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lendo o seu plano…`)
};

const es_419_coach_extra_activity_reading_plan = /** @type {(inputs: Coach_Extra_Activity_Reading_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo tu plan…`)
};

const pt_pt2_coach_extra_activity_reading_plan = /** @type {(inputs: Coach_Extra_Activity_Reading_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A ler o teu plano…`)
};

const fr_fr2_coach_extra_activity_reading_plan = /** @type {(inputs: Coach_Extra_Activity_Reading_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecture de ton programme…`)
};

const de_de2_coach_extra_activity_reading_plan = /** @type {(inputs: Coach_Extra_Activity_Reading_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lese deinen Plan…`)
};

const it_it2_coach_extra_activity_reading_plan = /** @type {(inputs: Coach_Extra_Activity_Reading_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggo la tua scheda…`)
};

/**
* | output |
* | --- |
* | "Reading your plan…" |
*
* @param {Coach_Extra_Activity_Reading_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_activity_reading_plan = /** @type {((inputs?: Coach_Extra_Activity_Reading_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Activity_Reading_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_activity_reading_plan(inputs)
	if (locale === "es-419") return es_419_coach_extra_activity_reading_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_activity_reading_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_activity_reading_plan(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_activity_reading_plan(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_activity_reading_plan(inputs)
	return en_us2_coach_extra_activity_reading_plan(inputs)
});
export { coach_extra_activity_reading_plan as "coach-extra.activity_reading_plan" }